/* VERANE theme — interactions */
(function(){
  // sticky header condense
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function(){
      header.classList.toggle('shrink', window.scrollY > 60);
    });
  }

  // scroll reveals
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  // mobile menu toggle
  var burger = document.querySelector('.burger');
  var drawer = document.getElementById('mobile-drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function(){ drawer.classList.toggle('open'); });
  }

  // PDP: sticky enquiry bar appears once the gallery scrolls out
  var bar = document.getElementById('stickybar');
  var stage = document.getElementById('stage');
  if (bar && stage) {
    window.addEventListener('scroll', function(){
      bar.classList.toggle('show', stage.getBoundingClientRect().bottom < 0);
    });
  }

  // PDP gallery: thumbnail swap (high-res) + click-to-enlarge lightbox
  var pdpStage = document.getElementById('stage');
  var pdpMain = document.getElementById('mainart');
  var lb = document.getElementById('lightbox');
  var lbImg = document.getElementById('lightbox-img');

  document.querySelectorAll('.thumb').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('.thumb').forEach(function(x){ x.classList.remove('active'); });
      t.classList.add('active');
      if (!pdpMain) return;
      var img = t.querySelector('img');
      var svg = t.querySelector('svg');
      var full = t.getAttribute('data-full');
      var zoom = t.getAttribute('data-zoom');
      if (full) {
        pdpMain.innerHTML = '<img src="'+full+'" alt="'+(img ? (img.alt||'') : '')+'">';
        if (pdpStage && zoom) pdpStage.setAttribute('data-zoom', zoom);
      } else if (img) {
        pdpMain.innerHTML = '<img src="'+img.src+'" alt="'+(img.alt||'')+'">';
      } else if (svg) {
        pdpMain.innerHTML = svg.outerHTML;
      }
    });
  });

  // click the main image to enlarge (lightbox)
  if (pdpStage && lb && lbImg) {
    pdpStage.addEventListener('click', function(){
      var src = pdpStage.getAttribute('data-zoom');
      var cur = pdpMain && pdpMain.querySelector('img');
      if (!src && cur) src = cur.src;
      if (!src) return;
      lbImg.src = src;
      lbImg.alt = cur ? (cur.alt || '') : '';
      lb.hidden = false;
      document.body.classList.add('lb-open');
    });
    var closeLb = function(){ lb.hidden = true; lbImg.src = ''; document.body.classList.remove('lb-open'); };
    lb.addEventListener('click', closeLb);
    var lbClose = document.getElementById('lightbox-close');
    if (lbClose) lbClose.addEventListener('click', function(e){ e.stopPropagation(); closeLb(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && lb && !lb.hidden) closeLb(); });
  }
})();


/* Hero carousel — rotate the headline pieces */
(function(){
  var hc = document.getElementById('heroCarousel');
  if (!hc) return;
  var slides = hc.querySelectorAll('.hero-slide');
  var dots = hc.querySelectorAll('.hero-dot');
  if (slides.length < 2) return;
  var idx = 0, timer;
  function show(n){
    slides[idx].classList.remove('active');
    if (dots[idx]) dots[idx].classList.remove('active');
    idx = (n + slides.length) % slides.length;
    slides[idx].classList.add('active');
    if (dots[idx]) dots[idx].classList.add('active');
  }
  function start(){ timer = setInterval(function(){ show(idx + 1); }, 5000); }
  Array.prototype.forEach.call(dots, function(d){
    d.addEventListener('click', function(e){ e.preventDefault(); show(parseInt(d.getAttribute('data-i'), 10)); clearInterval(timer); start(); });
  });
  start();
})();
